import { BREAKPOINTS } from 'artkive/utils/constants'
import theme from 'artkive/utils/theme'

export const alsoLoveStyles = ({ breakpoints }) => ({
  root: {
    [breakpoints.up('md')]: {
      background: theme.colors.sky[300],
    },
  },
  slides: {
    [breakpoints.up(BREAKPOINTS.lg)]: {
      margin: 0,
    },
  },
  content: {
    [breakpoints.up('lg')]: {
      marginLeft: 100,
      marginRight: 100,
    },
  },
  // The book slide sets its price as an h2; the keepsake frames show it at body size and color.
  price: {
    '& .MuiTypography-h2': {
      fontSize: 'inherit',
      lineHeight: 'inherit',
      color: 'inherit',
    },
  },
  button: {
    [breakpoints.down('sm')]: {
      alignSelf: 'center',
      width: '100%',
      maxWidth: 220,
      padding: '12px 24px',
    },
  },
  lines: {},
})
